import React from 'react';
import Profil from "./Profil";
import ListItem from "./ListItem";

const ITEM_RENDERERS = {
    profile: (content) => (
        <Profil
            id={content.id}
            title={content.header}
            name={content.name}
            mobile={content.mobile}
            mail={content.mail}
            image={content.imageUrl}
        />
    ),
    listItem: (content) => {
        <ListItem
            id={content.id}
            title={content.header}
            text={content.text}
            layout={content.layout}
        />
    },
};

export default function renderItem(item, content) {
    if (!content) return null;
    const render = ITEM_RENDERERS[item.type];
    if (!render) return null;

    // key still has to be attached externally, regardless of how each type handles its own id/anchor.
    return <React.Fragment key={item.sectionKey}>{render(content)}</React.Fragment>;
}